/* ═══════════════════════════════════════════════
   Jessica Nails — Carrito Global
   Archivo: assets/jessica-cart.js
   ═══════════════════════════════════════════════ */

(function() {

const CART_KEY = 'jn_cart';

/* ── STORAGE ── */
function getCart() {
  try { return JSON.parse(localStorage.getItem(CART_KEY)) || {}; }
  catch(e) { return {}; }
}

function saveCart(cart) {
  try { localStorage.setItem(CART_KEY, JSON.stringify(cart)); }
  catch(e) {}
}

/* ── API PÚBLICA ── */
window.jnCart = {

  add: function(item) {
    // item: { key, code, name, price, type, meta }
    const cart = getCart();
    cart[item.key] = item;
    saveCart(cart);
    this.update();
    this.showBadge();
  },

  remove: function(key) {
    const cart = getCart();
    delete cart[key];
    saveCart(cart);
    this.update();
  },

  toggle: function(item) {
    const cart = getCart();
    if (cart[item.key]) {
      delete cart[item.key];
    } else {
      cart[item.key] = item;
    }
    saveCart(cart);
    this.update();
    return !cart[item.key] === false; // true if added
  },

  has: function(key) {
    return !!getCart()[key];
  },

  getAll: function() {
    return Object.values(getCart());
  },

  clear: function() {
    saveCart({});
    this.update();
  },

  update: function() {
    const items = this.getAll();
    const total = items.reduce((s, p) => s + (p.price || 0), 0);

    // Badge
    const badge = document.getElementById('jn-cart-badge');
    if (badge) {
      badge.textContent = items.length;
      badge.style.display = items.length > 0 ? 'flex' : 'none';
    }

    // Total
    const totalEl = document.getElementById('jn-drawer-total');
    if (totalEl) totalEl.textContent = '$' + total.toLocaleString() + '.00';

    // WA button
    const waBtn = document.getElementById('jn-drawer-wa-btn');
    if (waBtn) waBtn.disabled = items.length === 0;

    // Items list
    const listEl = document.getElementById('jn-drawer-items');
    if (listEl) {
      if (items.length === 0) {
        listEl.innerHTML = '<div class="jn-drawer__empty">Toca cualquier producto<br>y agrégalo a tu pedido</div>';
      } else {
        listEl.innerHTML = items.map(p => `
          <div class="jn-cart-item">
            <div class="jn-cart-item__sw" style="background:${p.color || '#e0e0e0'}"></div>
            <div class="jn-cart-item__info">
              <div class="jn-cart-item__name">${p.name}</div>
              <div class="jn-cart-item__meta">${p.code}${p.meta ? ' · ' + p.meta : ''}</div>
              <div class="jn-cart-item__price">$${(p.price || 0).toLocaleString()}.00</div>
            </div>
            <button class="jn-cart-item__rm" onclick="jnCart.remove('${p.key}')">✕</button>
          </div>`).join('');
      }
    }

    // Update dots in color grid if function exists
    if (typeof jnUpdateDots === 'function') jnUpdateDots();
  },

  showBadge: function() {
    const badge = document.getElementById('jn-cart-badge');
    if (badge) {
      badge.classList.add('pop');
      setTimeout(() => badge.classList.remove('pop'), 300);
    }
  },

  sendWA: function() {
    const items = this.getAll();
    if (!items.length) return;
    const total = items.reduce((s, p) => s + (p.price || 0), 0);
    const lines = items.map(p =>
      `• ${p.name} (${p.code})${p.meta ? ' — ' + p.meta : ''} — $${(p.price || 0).toLocaleString()}`
    ).join('\n');
    const msg = `¡Hola! Me gustaría hacer el siguiente pedido Jessica Nails:\n\n${lines}\n\nTotal estimado: $${total.toLocaleString()}.00\n\n¿Está todo disponible?`;
    const wa = window.jnWANumber || '525567362860';
    window.open('https://wa.me/' + wa + '?text=' + encodeURIComponent(msg), '_blank');
  },

  open: function() {
    const drawer = document.getElementById('jn-drawer');
    const scrim = document.getElementById('jn-scrim');
    if (drawer) drawer.classList.add('open');
    if (scrim) scrim.classList.add('open');
  },

  close: function() {
    const drawer = document.getElementById('jn-drawer');
    const scrim = document.getElementById('jn-scrim');
    if (drawer) drawer.classList.remove('open');
    if (scrim) scrim.classList.remove('open');
  }
};

/* ── DRAWER HTML ── */
function injectDrawer() {
  if (document.getElementById('jn-global-drawer')) return;

  const el = document.createElement('div');
  el.id = 'jn-global-drawer';
  el.innerHTML = `
    <div class="jn-scrim" id="jn-scrim" onclick="jnCart.close()"></div>
    <div class="jn-drawer" id="jn-drawer">
      <div class="jn-drawer__head">
        <span class="jn-drawer__title">Mi pedido</span>
        <button class="jn-drawer__close" onclick="jnCart.close()">✕</button>
      </div>
      <div class="jn-drawer__items" id="jn-drawer-items">
        <div class="jn-drawer__empty">Toca cualquier producto<br>y agrégalo a tu pedido</div>
      </div>
      <div class="jn-drawer__foot">
        <div class="jn-drawer__total-row">
          <span>Total estimado</span>
          <span id="jn-drawer-total">$0.00</span>
        </div>
        <button class="jn-wa-btn" id="jn-drawer-wa-btn" onclick="jnCart.sendWA()" disabled>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="white"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
          Enviar pedido por WhatsApp
        </button>
        <p class="jn-drawer__note">Recibirás la lista con códigos y total.</p>
      </div>
    </div>`;
  document.body.appendChild(el);
}

/* ── CART BUTTON IN HEADER ── */
function injectCartBtn() {
  if (document.getElementById('jn-cart-btn')) return;

  // Hide native Shopify cart icon
  const style = document.createElement('style');
  style.textContent = `
    .header__icon--cart, a[href="/cart"] > .icon-bag, 
    header a[href*="/cart"] { display: none !important; }
  `;
  document.head.appendChild(style);

  // Find header icons area
  const headerIcons = document.querySelector('.header__icons-wrapper, [class*="header__icons"]');
  if (!headerIcons) return;

  const btn = document.createElement('button');
  btn.id = 'jn-cart-btn';
  btn.onclick = () => jnCart.open();
  btn.innerHTML = `
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
      <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
      <line x1="3" y1="6" x2="21" y2="6"/>
      <path d="M16 10a4 4 0 01-8 0"/>
    </svg>
    <span id="jn-cart-badge" style="display:none">0</span>
  `;
  headerIcons.appendChild(btn);
}

/* ── INIT ── */
document.addEventListener('DOMContentLoaded', function() {
  injectDrawer();
  injectCartBtn();
  jnCart.update();
});

})();
